import React, {Dispatch, SetStateAction, useCallback, useEffect, useState} from "react"


export const useDetectScroll = () => {
    const [scrollDir, setScrollDir] = useState("");

    useEffect(() => {
        const threshold = 0;
        let lastScrollY = window.pageYOffset;
        let ticking = false;

        const updateScrollDir = () => {
            const scrollY = window.pageYOffset;

            // console.log("scrolly-- ", scrollY, " -lastcsroll== ", lastScrollY)

            if (Math.abs(scrollY - lastScrollY) < threshold) {
                ticking = false;
                return;
            }
            setScrollDir(scrollY > lastScrollY ? "scrolling down" : "scrolling up");
            lastScrollY = scrollY > 0 ? scrollY : 0;
            ticking = false;
        }

        const onScroll = () => {
            if (!ticking) {
            window.requestAnimationFrame(updateScrollDir);
            ticking = true;
            }
        }

        window.addEventListener("scroll", onScroll);
        // console.log(scrollDir);

        return () => window.removeEventListener("scroll", onScroll)
    }, [scrollDir]);

    return { scrollDir }

}